import classNames from "classnames";
import { forwardRef } from "react";

interface TabContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
}

export const TabContainer = forwardRef(
  ({ title, className, children }: TabContainerProps, ref: any) => {
    return (
      <section ref={ref} className="flex-1 overflow-auto w-full pb-16 px-3">
        <p className="text-center pt-5 pb-2 text-lg font-medium shrink-0 md:block hidden">
          {title}
        </p>
        <div className={classNames("max-w-6xl mx-auto", className)}>
          {children}
        </div>
      </section>
    );
  }
);
